module.exports = __webpack_public_path__ + "static/media/plusIcon.ea9c9ca7.svg";